'use client'

import { useSession } from 'session/src/hooks/useSession'
import { getFromSessionStorage } from 'utils/webStorage/sessionStorage'

export const GUEST_EMAIL_CACHE_KEY = 'guestEmail'

export const useGuestEmail = () => {
	const { logged } = useSession()

	if (logged) {
		return null
	}

	return getFromSessionStorage<string>(GUEST_EMAIL_CACHE_KEY)
}
